import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class FiltersProvider extends HttpRequest {
  async createFilter (payload) {
    this.setHeader(getAuthToken())
    return this.create('/filters', payload)
  }

  async getFilterByQuery (payload) {
    this.setHeader(getAuthToken())
    return this.fetch(`/filters/?search=${payload}`)
  }

  async getFilterByID (param) {
    this.setHeader(getAuthToken())
    return this.fetch(`/filters/${param}`)
  }

  async deleteByID (query) {
    this.setHeader(getAuthToken())
    return this.delete(`/filters/?id=${query}`)
  }

  async getAllFilters () {
    this.setHeader(getAuthToken())
    return this.fetch('/filters')
  }

  async getFiltersWithOptions (options, searchText) {
    this.setHeader(getAuthToken())
    const sortOrder = options.sortDesc[0] ? 'asc' : 'desc'
    const params = [
      `page=${options.page}`,
      `limit=${options.itemsPerPage}`,
      `sort_by=${options.sortBy[0]}`,
      `sort_order=${sortOrder}`,
      `search=${searchText}`
    ].join('&')
    return this.fetch(`/filters?${params}`)
  }
}

export default FiltersProvider
